import ContactIconDark from 'assets/images/icons/dark - contact.svg?react';
import ContactIconSimpleFiligree from 'assets/images/icons/simple filigree - contact.svg?react';
import ContactIconSpringVibes from 'assets/images/icons/spring - contact.svg?react';
import ContactIconVickyBaumannBoho from 'assets/images/icons/vicky boho - contact.svg?react';
import ContactIconVickyBaumannFineart from 'assets/images/icons/vicky fineart - contact.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacyContactIcon = (props: IIconProps) =>
  useTemplateVariant({
    classic: () => <BaseIcon icon={ContactIconSimpleFiligree} {...props} />,
    dark: () => <BaseIcon icon={ContactIconDark} {...props} />,
    simpleFiligree: () => <BaseIcon icon={ContactIconSimpleFiligree} {...props} />,
    springVibes: () => <BaseIcon icon={ContactIconSpringVibes} {...props} />,
    vickyBaumannBoho: () => <BaseIcon icon={ContactIconVickyBaumannBoho} {...props} />,
    vickyBaumannFineart: () => <BaseIcon icon={ContactIconVickyBaumannFineart} {...props} />,
    breeze: () => <BaseIcon icon={ContactIconSimpleFiligree} {...props} />,
    capri: () => <BaseIcon icon={ContactIconSimpleFiligree} {...props} />,
    rose: () => <BaseIcon icon={ContactIconSimpleFiligree} {...props} />,
    calm: () => <BaseIcon icon={ContactIconSimpleFiligree} {...props} />
  })();

export const ContactIcon = (props: IIconProps) => (
  <SetIcon slug="camera" fallback={LegacyContactIcon} {...props} />
);
